window.$ = window.jQuery;
require('./app-custom');